import styles from "./style.module.scss";

type TitleType = {
  text: string;
  shadowText: string;
  containerStyle?: string;
  shadowStyle?: string;
  titleStyle?: string;
};
const Title: React.FC<TitleType> = ({
  text,
  shadowText,
  containerStyle = "",
  shadowStyle = "",
  titleStyle = "",
}) => {
  return (
    <div className={`${styles.titleContainer} ${containerStyle}`}>
      <text className={`${styles.shadow} ${shadowStyle}`}>{shadowText}</text>
      <text className={`${styles.title} ${titleStyle}`}>{text}</text>
    </div>
  );
};

export default Title;
